import pythonApi from '../api/pythonApi';

export interface ISensorboxOption {
  id: string;
  name: string;
}

export interface ISensorboxGroupOption {
  id: string;
  name: string;
  sensorboxes: ISensorboxOption[];
}

export interface IAssetGroupOption {
  asset_group_id: string;
  asset_group_name: string;
  groups: ISensorboxGroupOption[];
}

export interface IMonthlyReportOptionsResponse {
  asset_groups: IAssetGroupOption[];
}

export interface ICreateMonthlyReportJobPayload {
  asset_group_id: string;
  month: number;
  year: number;
  start_date?: string;
  end_date?: string;
  selected_group_ids: string[];
  selected_sensorbox_ids: string[];
}

export interface IMonthlyReportJobStatus {
  job_id: string;
  status: 'queued' | 'running' | 'succeeded' | 'delivered' | 'failed';
  error?: string | null;
  file?: {
    file_name: string;
    file_size: number;
  } | null;
}

export interface IAssetGroupReportHistoryItem {
  id: string;
  job_id: string;
  org_id?: string | null;
  asset_group_id: string;
  asset_group_name: string;
  requested_by_uid: string;
  requested_by_email: string;
  status: string;
  start_date: string;
  end_date: string;
  file_name?: string | null;
  file_size?: number | null;
  pptx_file_name?: string | null;
  pptx_file_size?: number | null;
  storage_type?: string | null;
  error?: string | null;
  step?: string | null;
  created_at: number;
  updated_at: number;
  completed_at?: number | null;
}

export interface IAssetGroupReportHistoryResponse {
  items: IAssetGroupReportHistoryItem[];
  total: number;
}

class MonthlyReportService {
  getOptions = async (): Promise<IMonthlyReportOptionsResponse> => {
    const response = await pythonApi.get('/api/v1/monthly-reports/options');
    return response.data;
  };

  createJob = async (payload: ICreateMonthlyReportJobPayload): Promise<{ job_id: string }> => {
    const response = await pythonApi.post('/api/v1/monthly-reports/jobs', payload);
    return response.data;
  };

  getJobStatus = async (jobId: string): Promise<IMonthlyReportJobStatus> => {
    const response = await pythonApi.get(`/api/v1/monthly-reports/jobs/${jobId}`);
    return response.data;
  };

  downloadJobFile = async (jobId: string) => {
    return pythonApi.get(`/api/v1/monthly-reports/jobs/${jobId}/download`, { responseType: 'blob' });
  };

  getHistory = async (assetGroupId: string, page = 1, limit = 10): Promise<IAssetGroupReportHistoryResponse> => {
    const response = await pythonApi.get('/api/v1/monthly-reports/history', {
      params: { asset_group_id: assetGroupId, page, limit },
    });
    return response.data;
  };

  downloadHistoryReport = async (reportId: string, format: 'xlsx' | 'pptx' = 'xlsx') => {
    return pythonApi.get(`/api/v1/monthly-reports/history/${reportId}/download`, {
      params: { format },
      responseType: 'blob',
    });
  };
}

export default new MonthlyReportService();
